var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKriz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 21H10.28C8.65999 21 7.10999 20.31 6.02999 19.12L2.49999 15.24C0.81999 13.4 0.81999 10.62 2.49999 8.77L6.02999 4.89C7.10999 3.69 8.65999 3 10.28 3H17C20.17 3 22.75 5.58 22.75 8.75V15.25C22.75 18.42 20.17 21 17 21ZM10.28 4.5C9.08999 4.5 7.93999 5.01 7.13999 5.89L3.59999 9.78C2.44999 11.05 2.44999 12.96 3.59999 14.23L7.12999 18.11C7.92999 18.99 9.07999 19.5 10.27 19.5H17C19.34 19.5 21.25 17.59 21.25 15.25V8.75C21.25 6.41 19.34 4.5 17 4.5H10.28Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.22C15.81 15.22 15.62 15.15 15.47 15L10.53 10.05C10.24 9.75999 10.24 9.27999 10.53 8.98999C10.82 8.69999 11.3 8.69999 11.59 8.98999L16.53 13.94C16.82 14.23 16.82 14.71 16.53 15C16.38 15.15 16.19 15.22 16 15.22Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.06 15.22C10.87 15.22 10.68 15.15 10.53 15C10.24 14.71 10.24 14.23 10.53 13.94L15.47 9C15.76 8.71 16.24 8.71 16.53 9C16.82 9.29 16.82 9.77 16.53 10.06L11.59 15C11.44 15.15 11.25 15.22 11.06 15.22Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKriz);
export default __webpack_public_path__ + "static/media/kriz.334062f5fd4517cf0a0bd8707c70e9b8.svg";
export { ForwardRef as ReactComponent };